<template>
  <div v-hover v-if="!block.hasOwnProperty('disableInputs')">
    <v-btn small @click="showFormDialog = true">
      <v-icon small left>mdi-cog</v-icon>Configure Actions
    </v-btn>
    <v-dialog v-model="showFormDialog" width="900px" scrollable>
      <FormConfigurationContent :block="block" @close="showFormDialog = false"></FormConfigurationContent>
    </v-dialog>
  </div>
</template>

<script>
import projectMixin from "../project-mixin";
import FormConfigurationContent from "./FormConfigurationContent";

export default {
  props: ["block"],
  components: { FormConfigurationContent },
  mixins: [projectMixin],
  data() {
    return {
      showFormDialog: false
    };
  }
};
</script>